// extracted by mini-css-extract-plugin
module.exports = {"list_container":"InformationList_list_container__Oc8zj"};